import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { timeAgo } from "@/components/mh/bits";
import { Receipt } from "@/components/mh/Receipt";

const STEP_COLOR = { done: "#D4FF3A", waiting: "#FFB020", rejected: "#FF3B5C", pending: "rgba(255,255,255,0.08)" };

const RUN_LABEL = {
  running: { t: "Running", c: "text-[#D4FF3A]" },
  awaiting_approval: { t: "Needs you", c: "text-[#FFB020]" },
  completed: { t: "Shipped", c: "text-muted-foreground" },
  rejected: { t: "Rejected", c: "text-[#FF3B5C]" },
  failed: { t: "Failed", c: "text-[#FF3B5C]" },
};

export const FlowSteps = ({ steps, compact }) => (
  <div className="flex items-center gap-1 w-full">
    {steps.map((s) => (
      <div key={s.name} className="flex-1 min-w-0">
        <div
          className={cn("h-1.5 rounded-full transition-[background-color] duration-500", s.status === "waiting" && "mh-blink")}
          style={{ background: STEP_COLOR[s.status] || STEP_COLOR.pending }}
        />
        {!compact && <div className="font-mono text-[9px] uppercase tracking-wider text-muted-foreground mt-1 truncate">{s.name}</div>}
      </div>
    ))}
  </div>
);

export const FlowRun = ({ run, deptHex, compact }) => {
  const st = RUN_LABEL[run.status] || RUN_LABEL.running;
  return (
    <div className="mh-enter py-3 border-b border-white/[0.05] last:border-0" data-testid={`flow-run-${run.id}`}>
      <div className="flex items-center gap-2 mb-2 min-w-0">
        <span className="w-1.5 h-1.5 rotate-45 flex-shrink-0" style={{ background: deptHex }} />
        <Link to={`/atlas/${run.agent_slug}`} className="text-sm font-medium truncate hover:underline underline-offset-4">{run.agent_name}</Link>
        <span className="text-xs text-muted-foreground truncate hidden sm:inline">· {run.artifact}</span>
        <span className={cn("ml-auto font-mono text-[10px] uppercase tracking-wider flex-shrink-0", st.c)}>{st.t}</span>
      </div>
      <FlowSteps steps={run.steps} compact={compact} />
      <Receipt r={run.receipt} compact={compact} testId={`run-receipt-${run.id}`} />
      <div className="flex justify-between mt-1.5 font-mono text-[10px] text-muted-foreground/70">
        <span>{run.source} · conf {Math.round(run.confidence * 100)}%</span>
        <span>{timeAgo(run.updated_at)}</span>
      </div>
    </div>
  );
};
